exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Z-wR{padding:23px;background-color:#f7f8f8;border-top:2px solid #fff;border-bottom:1px solid #e6e7e8}.SZXRY{font-size:24px;font-weight:400;line-height:1}._3jcZf{display:-webkit-box;display:-ms-flexbox;display:flex;text-transform:capitalize}._3jcZf a,._3jcZf span{color:#6d6e71;font-size:10px}._3jcZf i{position:relative;top:2px;color:#a1b1bc;margin:0 4px}", ""]);

// exports
exports.locals = {
	"root": "_2Z-wR",
	"title": "SZXRY",
	"breadcrumbs": "_3jcZf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./node_modules/sass-loader/lib/loader.js??ref--2-rules-4!./src/components/MiniNavSimple/MiniNavSimple.css
// module id = 2154
// module chunks = 1